<template lang="html">
  <div>
    <app-title title="Your bank account"></app-title>
    <div class="main-wrapper">
      <div v-if="$store.state.account.country === 'Japan'">
        <!-- <div class="user-form">
          <p>銀行名: </p>
          <input v-model="bankData.bank_name">
        </div>
        <div class="user-form">
          <p>支店名: </p>
          <input v-model="bankData.brunch_name">
        </div> -->
        <div class="user-form">
          <n-input
            v-model="bank_code"
            placeholder="銀行コード(4桁)"
            type="number"
          ></n-input>
        </div>
        <div class="user-form">
          <n-input
            v-model="branch_code"
            placeholder="支店コード(3桁)"
            type="number"
          ></n-input>
        </div>
        <p v-if="bankData.last4">最後の4桁: {{bankData.last4}}</p>
        <div class="user-form">
          <n-input
            v-model="bankData.account_number"
            placeholder="口座番号"
            type="number"
          ></n-input>
        </div>
        <div class="user-form">
          <n-input
            v-model="bankData.account_holder_name"
            placeholder="口座名義（カタカナ）"
            type="text"
          ></n-input>
        </div>
      </div>
      <div v-else>
        <div class="user-form">
          <n-input
            v-model="bankData.account_number"
            placeholder="account_number"
            type="number"
          ></n-input>
        </div>

        <div class="user-form">
          <n-input
            v-model="bankData.routing_number"
            placeholder="routing_number"
            type="number"
          ></n-input>
        </div>
        <div class="user-form">
          <n-input
            v-model="bankData.account_holder_name"
            placeholder="account_holder_name"
            type="text"
          ></n-input>
        </div>
      </div>
      <div class="btn-wrapper">
        <router-link :to="`/account/${this.$store.state.account.name}`">
          <btn size="normal" type="cancel" :label="lang[1]"></btn>
        </router-link>
        <btn size="normal" type="primary" :label="lang[2]" @click="create()" :loading="loading"></btn>
      </div>
    </div>
    <app-menu active="profile"></app-menu>
    <notice v-if="isNotice" :title="noticeTitle" :text="noticeText" :type="noticeType"></notice>
  </div>
</template>

<script>
import axios from 'axios'
import Btn from '../../components/Button.vue'
import AppMenu from '../../components/Menu.vue'
import AppTitle from '../../components/Title.vue'
import Notice from '../../components/Notice.vue'
import NInput from '../../components/Input.vue'
import stripeCountryMaster from '../../masters/stripeCountryMaster'
import stirpeCurrencyMaster from '../../masters/stirpeCurrencyMaster'
import AccountBankLangMaster from '../../masters/langMaster/AccountBankLangMaster'
import stripeErrorHandle from '../../mixins/stripeErrorHandle.js'

export default {
  name: 'Profile address',
  components: {
    Btn,
    AppMenu,
    Notice,
    AppTitle,
    NInput
  },

  mixins: [stripeErrorHandle],

  data() {
    return {
      lang: AccountBankLangMaster[this.$store.state.account.lang],
      bankData: {},
      bank_code: '',
      branch_code: '',
      isNotice: '',
      loading: '',
    }
  },

  created() {
    this.getBankData()
  },

  methods: {
    getBankData() {
      axios.get(`/private/bank/${this.$store.state.account.id}`)
      .then(data => {
        axios.get(`/private/stripe/bank/${this.$store.state.account.stripe_id}/${data.data.bank.bank_id}`)
        .then(data => {
          this.bankData = data.data.data
          this.bank_code = String(this.bankData.routing_number).substr(0, 4)
          this.branch_code = String(this.bankData.routing_number).substr(4, 7)
        }).catch(err => {
          console.log(err)
        })
      }).catch(err => {
        console.log(err)
      })
    },

    create() {
      this.loading = true
      this.bankData.object = "bank_account"
      this.bankData.country = stripeCountryMaster[this.$store.state.account.country]
      this.bankData.currency = stirpeCurrencyMaster[this.$store.state.account.country]
      this.bankData.account_holder_type = "individual"
      if(this.$store.state.account.country === "Japan") {
        this.bankData.routing_number = `${this.bank_code}${this.branch_code}`
      }
      if(this.bankData.id) {
        delete this.bankData.id
        delete this.bankData.account
        delete this.bankData.available_payout_methods
        delete this.bankData.bank_name
        delete this.bankData.fingerprint
        delete this.bankData.last4
        delete this.bankData.status
      }
      axios.post('/private/stripe/bank',{
        id: this.$store.state.account.stripe_id,
        external_account: this.bankData
      }).then(data => {
        this.loading = false
        this.createBankAccount(data.data.data.id)
      }).catch(err => {
        this.loading = false
        this.stripeErrorHandling(err)
      })
    },

    createBankAccount(id) {
      axios.post('/private/bank', {
        user_id: this.$store.state.account.id,
        bank_id: id
      }).then(data => {
        this.noticeType = 'success'
        this.noticeTitle = 'success!'
        this.noticeText = 'Your bank data has been successfly created!!'
        this.isNotice = true
        setTimeout(this.closeNotice, 5000)
        this.loading = false
      }).catch(err => {
        this.noticeType = 'err'
        this.noticeTitle = 'error'
        this.noticeText = 'internal server error'
        this.isNotice = true
        setTimeout(this.closeNotice, 5000)
        this.loading = false
        console.log(err)
      })
    },
  }
}
</script>

<style lang="css" scoped>
.profile {
  margin-bottom: 70px
}

.user-form {
  margin: 20px;
  display: flex;
}

.main {
  padding-bottom: 100px;
}

.select-wrapper::after {
  right: 0%;
}

@media(min-width: 800px) {
  .user-image {
    height: 30vh;
  }

  .profile-wrapper {
    width: 90%;
    max-width: 800px;
    margin: 40px auto;
  }
}
</style>
